import { useEffect } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { IAuthContext } from "./AuthContext.types";
import { loginRequest } from "../../../authConfig";
import { ACCESS_TOKEN_KEY } from "./AuthContext.consts";

const handleLogin = (instance: any) => {
  instance.loginRedirect(loginRequest).catch((e: any) => {
    console.error(e);
  });
};

export const useAuth = (): IAuthContext => {
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const isInitializing =
    inProgress === InteractionStatus.Login ||
    inProgress === InteractionStatus.HandleRedirect ||
    inProgress === InteractionStatus.Startup;

  const requestAccessToken = async () => {
    const request = {
      ...loginRequest,
      account: accounts[0],
    };

    instance
      .acquireTokenSilent(request)
      .then((response) => {
        localStorage.setItem(
          ACCESS_TOKEN_KEY,
          response.accessToken
        );
      })
      .catch((e) => {
        instance.acquireTokenPopup(request).then((response) => {
          localStorage.setItem(
            ACCESS_TOKEN_KEY,
            response.accessToken
          );
        });
      });
  };

  useEffect(() => {
    if (isAuthenticated) {
      requestAccessToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const login = () => handleLogin(instance);

  return {
    isAuthenticated,
    isInitializing,
    login,
  } as const;
};
